import React, { useState } from 'react';
import {
  IonAlert,
  IonContent,
  IonSlide,
  IonItem,
  IonIcon,
  IonLabel,
  IonButton,
  IonRow,
  IonCol,
  IonInput,
  IonGrid,
} from '@ionic/react';
import { personCircle } from 'ionicons/icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { register, login } from '../actions/authenticationActions';

function validateEmail(email) {
  // eslint-disable-next-line
  const re = /^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/;
  return re.test(String(email).toLowerCase());
}

const LoginSignup = ({ login, signup, register, isAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Please enter a valid email');
      setIsError(true);
      return;
    }
    if (validateEmail(email) === false) {
      setMessage('Your email is invalid');
      setIsError(true);
      return;
    }
    if (!password || password.length < 6) {
      setMessage('Please enter a password atleast having 6 characters');
      setIsError(true);
      return;
    }

    const loginData = {
      email: email,
      password: password,
    };

    try {
      login(loginData);
    } catch (error) {
      setMessage('Auth failure!');
      setIsError(true);
    }
  };

  const handleSignUp = (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Please enter your email');
      setIsError(true);
      return;
    }
    if (validateEmail(email) === false) {
      setMessage('Your email is invalid');
      setIsError(true);
      return;
    }
    if (!name) {
      setMessage('Please enter your name');
      setIsError(true);
      return;
    }
    if (!username) {
      setMessage('Please enter your username');
      setIsError(true);
      return;
    }
    if (!password) {
      setMessage('Please enter your password');
      setIsError(true);
      return;
    }
    if (password.length < 6) {
      setMessage('Password should be atleast 6 characters');
      setIsError(true);
      return;
    }

    const signUpData = {
      email: email,
      password: password,
      name: name,
      username: username,
    };

    try {
      register(signUpData);
    } catch (error) {
      setMessage('Auth failure!');
      setIsError(true);
    }
  };

  if (isAuthenticated) {
    window.location = '/dash';
  }

  return (
    <IonContent fullscreen className='ion-padding ion-text-center'>
      <IonSlide>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonAlert
                isOpen={isError}
                onDidDismiss={() => setIsError(false)}
                cssClass='my-custom-class'
                header={'Error!'}
                message={message}
                buttons={['Dismiss']}
              />
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <IonIcon style={{ fontSize: '70px', marginBottom: '24px' }} icon={personCircle} color='secondary' />
            </IonCol>
          </IonRow>
          <IonRow className='ion-justify-content-center'>
            <IonCol sizeLg='4' sizeMd='auto'>
              <IonItem>
                <IonLabel position='floating'> Email</IonLabel>
                <IonInput type='email' value={email} onIonChange={(e) => setEmail(e.detail.value)}></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          {signup && (
            <>
              <IonRow className='ion-justify-content-center'>
                <IonCol sizeLg='4' sizeMd='auto'>
                  <IonItem>
                    <IonLabel position='floating'>Name</IonLabel>
                    <IonInput type='Text' value={name} onIonChange={(e) => setName(e.detail.value)}></IonInput>
                  </IonItem>
                </IonCol>
              </IonRow>

              <IonRow className='ion-justify-content-center'>
                <IonCol sizeLg='4' sizeMd='auto'>
                  <IonItem>
                    <IonLabel position='floating'>Username</IonLabel>
                    <IonInput type='Text' value={username} onIonChange={(e) => setUsername(e.detail.value)}></IonInput>
                  </IonItem>
                </IonCol>
              </IonRow>
            </>
          )}

          <IonRow className='ion-justify-content-center'>
            <IonCol sizeLg='4' sizeMd='auto'>
              <IonItem>
                <IonLabel position='floating'> Password</IonLabel>
                <IonInput type='password' value={password} onIonChange={(e) => setPassword(e.detail.value)}></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>
          <IonRow className='ion-justify-content-center'>
            <IonCol sizeLg='3' sizeMd='auto'>
              {signup ? (
                <IonButton expand='block' style={{ marginTop: '32px' }} onClick={handleSignUp}>
                  SIGN UP
                </IonButton>
              ) : (
                <IonButton expand='block' style={{ marginTop: '32px' }} onClick={handleLogin}>
                  LOGIN
                </IonButton>
              )}

              <p style={{ fontSize: 'medium' }}>
                {signup ? (
                  <>
                    Have an account? <a href='login'>Login!</a>
                  </>
                ) : (
                  <>
                    Do not have an account? <a href='register'>Sign up!</a>
                  </>
                )}
              </p>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonSlide>
    </IonContent>
  );
};

LoginSignup.propTypes = {
  register: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    isAuthenticated: state.register.isAuthenticated,
  };
};

export default connect(mapStateToProps, { register, login })(LoginSignup);
